import { forwardRef } from "react";
import styled from "styled-components";

type Props = {
  readonly src: string;
  readonly isVisible: boolean;
  readonly onEnded: () => void;
};
type StyleProps = {
  readonly isVisible: boolean;
};

const StyledVideo = styled.video<StyleProps>`
  object-fit: contain;
  object-position: center;
  position: fixed;
  height: 100vh;
  width: 100vw;
  opacity: ${({ isVisible }: StyleProps) => (isVisible ? 1 : 0)};
`;

export const Video = forwardRef<HTMLVideoElement, Props>(
  ({ src, isVisible, onEnded }, ref) =>
    isVisible ? (
      <StyledVideo
        ref={ref}
        preload="auto"
        autoPlay
        onEnded={onEnded}
        isVisible={isVisible}
      >
        <source src={src} />
      </StyledVideo>
    ) : null
);
